<template>
    <div>
        <p-button @click="onSaveUserGroups()" outline class="hover-text min float-right"><i class="fa fa-check"></i><span>{{ $t('button.save') }}</span></p-button>                         

        <RequestInfo :type="infoType" :ok="ok" :error="error" :loader="loading" />

        <b-table 
            striped 
            hover 
            selectable 
            select-mode="single" 
            :items="usersGroups" 
            :fields="fields" 
            :per-page="perPage"
            :current-page="currentPage">

            <template v-slot:cell(selected)="{ item }">
                <input type="checkbox" :id="item.id" v-model="item.selected">
            </template>
            
        </b-table>

        <TablePagination 
            :total-rows="totalRows" 
            :per-page="perPage" 
            @pageChange="onPageChange">
        </TablePagination>
    </div>
</template>

<script>

import TablePagination from '@/components/Misc/TablePagination'

export default {
    components: { TablePagination },
        props: {
            item: {
                required: true,
            }
        },
        data() {
            return {
                perPage: 20,
                currentPage: 1,
                fields: [
                    { key: "id", label: this.$t('users.id') },
                    { key: "description", label: this.$t('users.description') },
                    { key: "selected", label: ""}
                ],
                usersGroups: [],
                ok: false,
                error: false,
                loading: false,
                infoType: "save"
            }
    },
    computed: {
        totalRows() {
            return this.usersGroups ? this.usersGroups.length : 0;
        },
        selectedUserGroups() {
            var selectedItems = [];
            
            for (var ug of this.usersGroups) {
                if( ug.selected ) {
                    selectedItems.push(ug);
                }
            }
            return selectedItems;               
        }                             
    },
    created() {
        this.getUsersGroups(this.item.id);
        
    },
    watch: {
        item: function(item) {
            this.getUsersGroups(item.id);
            this.ok = this.error = this.loading = false;                        
        },
    }, 
    methods: {
        getUsersGroups(item) {
            this.$store.dispatch('userDataHandler/getUsersGroups' , item ).then( response => {
                this.usersGroups = response.data.usergroups;
            });                
       },
       onSaveUserGroups(event) {
            if( event ) 
                event.preventDefault();   
            this.ok = this.error = false;
            this.infoType = "save";
            this.loading = true;
            
            if (!this.selectedUserGroups || this.selectedUserGroups.length === 0) {
                this.$store.dispatch('userDataHandler/deleteUsersGroups', this.item.id).then(response => {
                    this.ok = response.data.errorCode == 0;
                    this.error = !this.ok;
                })
                .catch( () => { 
                    this.error = true; 
                }) 
                .finally(() => {
                    setTimeout(() => { 
                        this.loading = false;
                        this.$emit('updateItem', this.item);
                    }, 1000);
                })
            } else {
                this.$store.dispatch('userDataHandler/saveUserGroups' , this.selectedUserGroups, this.item.id).then(response => {
                    this.ok = response.data.errorCode == 0;
                    this.error = !this.ok;
                })
                .catch( () => { 
                    this.error = true; 
                }) 
                .finally(() => {
                    setTimeout(() => { 
                        this.loading = false;
                        this.$emit('updateItem', this.item);
                    }, 1000);
                })
            }
        },
        onPageChange(page){
            this.currentPage = page
        }
    }
}
</script>
